import Axios from "./axios";

const resource = "career-sliders";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}